import type { ReactNode } from "react";

interface StepRightBlockProps {
  children: ReactNode;
}

export const StepRightBlock = ({ children }: StepRightBlockProps) => (
  <div className="relative flex size-full flex-col overflow-hidden">
    {/* Заголовок */}
    <p className="hidden md:block font-pixel text-neutral-50 pt-18 text-center text-[1.5rem]"> 
      Инструкция
    </p>

    {/* Сцена под контент */}
    <div className="relative flex-1 min-h-0">
      {children}
    </div>
  </div>
);
